/**
 * Dispatch 2 T2 P5 — shared mergeTagStrings utility (client-side).
 *
 * Byte-equivalent parallel of server/utils/mergeTags.ts. The dispatch-2-
 * merge-tags-equivalence vitest pins both files lockstep — any divergence
 * in implementation MUST fail the equivalence test.
 *
 * Used by ReviewTable.tsx's 7 tag-read sites (1851, 2367, 2399, 3052,
 * 5976, 6225, 6325) per Dispatch 2 T2. Canonical render now reads merged
 * manual_tags + auto_tags + legacy products.tags via this helper, replacing
 * the prior bug-class direct read of product.tags (which would return null
 * for new uploads written to manual_tags per BUILD-4 + RATIFIED N4).
 *
 * See server/utils/mergeTags.ts for the merge semantics doc.
 */
export function mergeTagStrings(...sources: (string | null | undefined)[]): string {
  const all: string[] = [];
  for (const s of sources) {
    if (!s) continue;
    for (const t of s.split(',')) {
      const trimmed = t.trim();
      if (trimmed.length > 0) all.push(trimmed);
    }
  }
  if (all.length === 0) return '';
  const distinct = Array.from(new Set(all));
  return distinct.join(', ');
}

/**
 * Convenience: merge a product's three tag fields per the BUILD-4 B-hybrid
 * shape. Used by ReviewTable's 7 tag-read sites — replaces the prior
 * `product.tags || ''` legacy read.
 */
export function mergeRenderTags(product: { manual_tags?: string | null; auto_tags?: string | null; tags?: string | null }): string {
  return mergeTagStrings(product.manual_tags, product.auto_tags, product.tags);
}
